import { useQuery } from '@tanstack/react-query';
import Addon from '../models/Addon';

export default function useAddons(isElementary = true) {
  return useQuery(['addons', isElementary ? 'elementary' : 'senior'], () => (
    Addon
      .includes('component')
      // `visibleToCustomers` is the STATUS half (draft and withdrawn add-ons
      // never reach a storefront); the audience flags below are unchanged.
      .where({ isElementary, isSenior: !isElementary, visibleToCustomers: true })
      .all()
      .then((res) => res.data)
  ), { placeholderData: [] });
}
